import Address               from "../../../domain/fundamentals/address/Address";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Email                 from "../../../domain/fundamentals/email/Email";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Office                from "../../../domain/office/Office";
import OfficeId              from "../../../domain/office/OfficeId";
import OfficeName            from "../../../domain/office/OfficeName";
import OfficeNameKana        from "../../../domain/office/OfficeNameKana";
import OfficeRepository      from "../../../domain/office/OfficeRepository";
import Offices               from "../../../domain/office/Offices";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import OfficeDataSource      from "../../../infrastructure/datasource/office/OfficeDataSource";

class GetOffices {
  private readonly repository: OfficeRepository = new OfficeDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(callback: (offices: Offices) => void) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.findAll();
      const list: Office[] = response.data.offices.map(office => new Office(
        new OfficeId(office.id),
        new OfficeName(office.name),
        new OfficeNameKana(office.name_kana),
        new Email(office.email_address),
        new Address(
          new PostalCode(office.address.postal_code),
          new Prefecture(office.address.prefecture),
          new City(office.address.city),
          new Street(office.address.street),
          new Building(office.address.building)
        )
      ));
      callback(new Offices(list));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetOffices;
